import { Data } from '@lottiefiles/dotlottie-react'
import { useEffect, useState } from 'react'

export const useStripesAnim = () => {
  const [stripesAnim, setStripesAnim] = useState<Data>()

  useEffect(() => {
    fetch('/lottie/stripes.lottie')
      .then((res) => res.arrayBuffer())
      .then((data) => setStripesAnim(data))
  }, [])

  return { stripesAnim }
}
